import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    height: 24,
    minWidth: 58,
    paddingHorizontal: 10,
    paddingVertical: 0,
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
  },

  label: {
    fontSize: 12,
    fontWeight: 450,
    lineHeight: 1,
  },
});
